var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-card", { staticClass: "viewer-360" }, [
    _c("div", { staticClass: "viewer-360__header" }, [
      _c("span", { staticClass: "viewer-360__title" }, [
        _c(
          "svg",
          {
            staticStyle: { "margin-right": "6px", "vertical-align": "middle" },
            attrs: {
              viewBox: "0 0 24 24",
              width: "18",
              height: "18",
              fill: "currentColor",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M12 4C7.6 4 4 7.6 4 12s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 11.5l-5-2.5V6h1.5v6.2l4 2-0.5 1.3z",
              },
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z",
              },
            }),
          ]
        ),
        _vm._v("\n            360° 뷰어\n        "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "viewer-360__header-right" },
        [
          _c("span", { staticClass: "viewer-360__hint" }, [
            _vm._v("← 좌우로 드래그 →"),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "" },
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          ),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "stage",
        staticClass: "viewer-360__stage",
        class: { "is-dragging": _vm.isDragging, "is-loaded": _vm.loaded },
        on: {
          pointerdown: function ($event) {
            $event.preventDefault()
            return _vm.onPointerDown.apply(null, arguments)
          },
          pointermove: function ($event) {
            $event.preventDefault()
            return _vm.onPointerMove.apply(null, arguments)
          },
          pointerup: _vm.onPointerUp,
          pointercancel: _vm.onPointerUp,
          touchstart: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        !_vm.loaded
          ? _c(
              "div",
              { staticClass: "viewer-360__loading" },
              [
                _c("v-progress-circular", {
                  attrs: { indeterminate: "", color: "primary", size: "48" },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "mt-2" }, [
                  _vm._v(
                    "이미지 로딩 중... " +
                      _vm._s(_vm.loadedCount) +
                      "/" +
                      _vm._s(_vm.frames.length)
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loaded,
              expression: "loaded",
            },
          ],
          ref: "viewImg",
          staticClass: "viewer-360__img",
          attrs: {
            src: _vm.currentFrameUrl,
            draggable: "false",
            alt: "360° 제품 이미지",
          },
        }),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "viewer-360__controls" },
      [
        _c("div", { staticClass: "viewer-360__frame-info" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.currentIndex + 1) +
              " / " +
              _vm._s(_vm.frames.length) +
              "\n        "
          ),
        ]),
        _vm._v(" "),
        _c(
          "v-btn",
          {
            staticClass: "viewer-360__play-btn",
            attrs: { text: "", small: "" },
            on: { click: _vm.toggleAutoplay },
          },
          [
            _c("v-icon", { attrs: { left: "", small: "" } }, [
              _vm._v(_vm._s(_vm.playing ? "mdi-pause" : "mdi-play")),
            ]),
            _vm._v(
              "\n            " +
                _vm._s(_vm.playing ? "정지" : "자동재생") +
                "\n        "
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "viewer-360__sensitivity" },
          [
            _c("span", [_vm._v("감도")]),
            _vm._v(" "),
            _c("v-slider", {
              staticStyle: { width: "80px" },
              attrs: {
                min: 2,
                max: 20,
                step: 1,
                dense: "",
                "hide-details": "",
              },
              model: {
                value: _vm.sensitivity,
                callback: function ($$v) {
                  _vm.sensitivity = $$v
                },
                expression: "sensitivity",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }